import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { ExcourtierScene } from "../../components/ExcourtierScene";
import { ExcPreorder } from "../../components/ExcPreorder";
import { pageColors } from "../../mock";
import { ArrowLeft, Instagram, Bell } from "lucide-react";

const Excourtier = () => {
  const navigate = useNavigate();
  useEffect(() => { document.title = "TMM|EXCOURTIER"; }, []);

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <ExcourtierScene />
      <div className="brand-page exc-with-scene">
        <button className="feed-back" onClick={() => navigate("/fashion")} data-testid="excourtier-back">
          <ArrowLeft size={16} /> Back to Fashion
        </button>

        <header className="brand-hero-center" data-testid="excourtier-hero">
          <img src="/img/exc.png" alt="Excourtier" className="brand-hero-mark exc" />
        </header>

        <section className="brand-preorder">
          <p className="brand-preorder-lead">
            Pieces are being finalized — drop your name to lock in a first-run
            garment.
          </p>
          <div className="brand-preorder-actions">
            <a
              href="https://www.instagram.com/excourtier__/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost"
              data-testid="excourtier-ig"
            >
              <Instagram size={16} /> @excourtier__
            </a>
            <button
              className="btn-solid btn-huge"
              onClick={() => navigate("/contact?source=excourtier")}
              data-testid="excourtier-notify"
            >
              <Bell size={16} /> Notify me at drop
            </button>
          </div>
        </section>

        <section className="brand-preorder-preview">
          <div className="brand-preorder-empty">
            Product photography is landing soon. Watch this page.
          </div>
        </section>

        <ExcPreorder />
      </div>
    </>
  );
};

export default Excourtier;
